import React, { FunctionComponent, useState } from 'react'
import { colors } from '@chegg-ui/theme'
import { useDispatch, useSelector } from 'react-redux'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { PROOFREADER_LEFT_PANEL_TEST_ID } from '@chegg-wt/core-wa/constants/paraphraser'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { OpenQuoteIcon } from '../icons/OpenQuoteIcon'
import { PlagiarismIcon } from '../icons/PlagiarismIcon'
import { MenuItem, ProofreaderLeftPanelContainer } from './styled'
import { MENU_ITEM } from './type'
import { PapersList } from './internal/PapersList'

const ProofReaderLeftPanel: FunctionComponent<{
  activeMenuItem: MENU_ITEM
}> = ({ activeMenuItem }) => {
  const [currentActiveMenuItem, setCurrentActiveMenuItem] = useState(activeMenuItem)
  const { toSourceTypeSelection, toPlagiarism } = useRoutesContext()
  const citationStyle = useSelector(currentStyleSelector)
  const dispatch = useDispatch()

  const onClickCitation = () => {
    dispatch(
      userClick({
        origin: origins.citationsLeftNavClick,
      })
    )
    setCurrentActiveMenuItem(MENU_ITEM.CITATIONS)
  }
  const onClickPlagiarism = () => {
    dispatch(
      userClick({
        origin: origins.plagiarismLeftNavClick,
      })
    )
    setCurrentActiveMenuItem(MENU_ITEM.PLAGIARISM)
  }

  return (
    <ProofreaderLeftPanelContainer
      data-test={`${PROOFREADER_LEFT_PANEL_TEST_ID}-container`}
    >
      <PapersList />
      <MenuItem
        href={toSourceTypeSelection({ style: citationStyle }).as}
        data-test={`${PROOFREADER_LEFT_PANEL_TEST_ID}-citation`}
        isActive={currentActiveMenuItem === MENU_ITEM.CITATIONS}
        leadingIcon={<OpenQuoteIcon color={colors.dark} />}
        onClick={onClickCitation}
        target="_blank"
      >
        {MENU_ITEM.CITATIONS}
      </MenuItem>
      <MenuItem
        href={toPlagiarism().href}
        data-test={`${PROOFREADER_LEFT_PANEL_TEST_ID}-plagiarism`}
        isActive={currentActiveMenuItem === MENU_ITEM.PLAGIARISM}
        leadingIcon={<PlagiarismIcon color={colors.dark} />}
        onClick={onClickPlagiarism}
        target="_blank"
      >
        {MENU_ITEM.PLAGIARISM}
      </MenuItem>
    </ProofreaderLeftPanelContainer>
  )
}

export default ProofReaderLeftPanel
